/**
 * Public page registry.
 *
 * Single source of truth for admin-controlled feature flags.
 * Used by PublicPagesContext, RequirePublicPage, and AdminSettings UI.
 */

export const PUBLIC_PAGES = {
  marketplace: {
    label: "Marketplace",
    description: "Buy and sell second-hand items. Disabling hides all marketplace routes and nav links.",
    defaultEnabled: true,
  },
  feed: {
    label: "Community Feed",
    description: "Social posts, battles, and match discovery. Disabling hides the feed route and nav link.",
    defaultEnabled: true,
  },
  compare: {
    label: "Product Comparison",
    description: "Side-by-side product comparison tool. Disabling hides the compare route and floating bar.",
    defaultEnabled: true,
  },
  forYou: {
    label: "For You Rail",
    description: "Personalized 'Picked for you' product rail on the home page. Off by default until validated.",
    defaultEnabled: false,
  },
  onboardingGuide: {
    label: "Onboarding Guide",
    description: "Guided tour and getting-started checklist for new users. Off by default until validated.",
    defaultEnabled: false,
  },
};
